import * as t from "io-ts";

export const LocationMetaShiftCodec = t.intersection([
  t.type({
    id: t.string,
    startDttm: t.number,
  }),
  t.partial({
    preDttm: t.number,
    endDttm: t.number,
    postDttm: t.number,
  }),
]);

export const LocationMetaShiftArrayCodec = t.array(
  LocationMetaShiftCodec
);

export type LocationMetaShift = t.TypeOf<typeof LocationMetaShiftCodec>;
